import { Controller } from "@hotwired/stimulus"

// Disables the answer area until the applicant has viewed all attached
// requirement files. Works in conjunction with files_viewer_controller
// which dispatches "files-viewer:file-viewed" events.
export default class extends Controller {
  static targets = ["overlay"]
  static values = { totalFiles: Number }

  connect() {
    this.viewedIndices = new Set()
    this.locked = true
    this.handleFileViewed = this.handleFileViewed.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)

    // Listen for file-viewed events bubbling up from the files-viewer
    this.element
      .closest(".requirement-field")
      ?.addEventListener("files-viewer:file-viewed", this.handleFileViewed)

    this.form = this.element.closest("form")
    this.form?.addEventListener("submit", this.handleFormSubmit)

    this.lockAnswerArea()
  }

  disconnect() {
    this.element
      .closest(".requirement-field")
      ?.removeEventListener("files-viewer:file-viewed", this.handleFileViewed)

    this.form?.removeEventListener("submit", this.handleFormSubmit)
  }

  handleFormSubmit(event) {
    if (!this.locked) return

    event.preventDefault()
    event.stopImmediatePropagation()

    // Briefly highlight the overlay to draw attention
    if (this.hasOverlayTarget) {
      this.overlayTarget.scrollIntoView({ behavior: "smooth", block: "center" })
      this.overlayTarget.classList.add("require-file-view-overlay--flash")
      setTimeout(() => {
        this.overlayTarget.classList.remove("require-file-view-overlay--flash")
      }, 1500)
    }
  }

  handleFileViewed(event) {
    const index = parseInt(event.detail?.index, 10)
    if (!isNaN(index)) {
      this.viewedIndices.add(index)
    }
    if (this.viewedIndices.size >= this.totalFilesValue) {
      this.unlockAnswerArea()
    }
  }

  lockAnswerArea() {
    this.locked = true
    this.element.classList.add("require-file-view-locked")
    // Disable all form inputs inside the answer area
    this.element.querySelectorAll("input, textarea, select, button").forEach(el => {
      el.dataset.requireFileViewDisabled = el.disabled ? "was-disabled" : "true"
      el.disabled = true
    })
  }

  unlockAnswerArea() {
    this.locked = false
    this.element.classList.remove("require-file-view-locked")
    this.form?.removeEventListener("submit", this.handleFormSubmit)
    if (this.hasOverlayTarget) {
      this.overlayTarget.style.display = "none"
    }
    // Re-enable form inputs that we disabled
    this.element.querySelectorAll("[data-require-file-view-disabled]").forEach(el => {
      if (el.dataset.requireFileViewDisabled !== "was-disabled") {
        el.disabled = false
      }
      delete el.dataset.requireFileViewDisabled
    })
  }
}
